import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.756 1.998H3.254a1.755 1.755 0 00-1.75 1.75v6.001a1.755 1.755 0 001.75 1.75h1.25V14l2.93-2.442a.25.25 0 01.16-.058h5.162a1.755 1.755 0 001.75-1.75V3.747a1.755 1.755 0 00-1.75-1.75z",
      stroke: "#2C6CED",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.01 7.751a1 1 0 100-2 1 1 0 000 2zM7.999 7.75a1 1 0 100-2 1 1 0 000 2zM11.012 7.75a1 1 0 100-2 1 1 0 000 2z",
      fill: "#2C6CED"
    }
  )
);
export {
  a as default
};
